import { configureStore } from '@reduxjs/toolkit';
import formsReducer from '../pages/Forms/formSlice';

export const store = configureStore({
    reducer: {
        forms: formsReducer
    },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export const RootState = store.getState
export const AppDispatch =  store.dispatch
